module.exports = __webpack_public_path__ + "static/media/lb.56f32195.svg";